import useCanonical from '../../hooks/use-canonical';
import LandingGlobal from './components/landing-global';
import LandingLocal from './components/landing-local';

function Landing() {
  const { canonical } = useCanonical();
  const entity = import.meta.env.VITE_DMHI_ENTITY;
  let component;

  if (entity === 'global' || entity === undefined) {
    component = <LandingGlobal />;
  } else {
    component = <LandingLocal />;
  }

  return (
    <>
      <link rel="canonical" href={canonical} />
      {component}
    </>
  );
}

export { default as landingLoader } from './loader';
export default Landing;
